"use client";

import { createContext, useContext } from "react";
import { DEFAULT_LOCALE } from "@/lib/i18n";

// The page's language for client components, set by app/[lang]/layout.tsx (outside the site's pages,
// such as the admin, it is English). A context rather than useParams, so components that render
// before any Suspense boundary (the menus) don't read the address while the page is prerendered.

const LangContext = createContext<string>(DEFAULT_LOCALE);

export function LangProvider({ lang, children }: { lang: string; children: React.ReactNode }) {
  return <LangContext.Provider value={lang}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
